import { defineRecipe, type SystemStyleObject } from '@chakra-ui/react/styled-system';

const checked: SystemStyleObject = {
  background: 'background/selected',
  borderColor: 'border/selected',
  color: 'text/primary',
  _icon: {
    color: 'icon/interactive',
  },
};

const checkedHover: SystemStyleObject = {
  background: 'background/selected-hover',
  borderColor: 'border/selected',
  color: 'text/primary',
  _icon: {
    color: 'icon/interactive-hover',
  },
};

const disabled: SystemStyleObject = {
  background: 'background/disabled',
  borderColor: 'border/disabled',
  color: 'text/on-disabled',
  cursor: 'not-allowed',
  _icon: {
    color: 'icon/on-disabled',
  },
};

const selectableTagRecipe = defineRecipe({
  className: 'selectable-tag',
  base: {
    alignItems: 'center',
    background: 'background/primary',
    border: '1px solid',
    borderColor: 'border/strong',
    borderRadius: '4',
    color: 'text/body',
    cursor: 'pointer',
    display: 'inline-flex',
    gap: '4',
    height: '24',
    paddingBlock: '4',
    paddingInline: '8',
    textStyle: 'comp/tag/sm',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    '&:has(svg)': {
      paddingInlineStart: '4',
    },
    _icon: {
      color: 'icon/secondary',
    },
    _hover: {
      background: 'background/hover',
      color: 'text/primary',
      _checked: checkedHover,
    },
    _checked: checked,
    _disabled: {
      ...disabled,
      _checked: disabled,
    },
    _focusVisible: {
      focusRing: 'outside',
    },
  },
});

export default selectableTagRecipe;
